import * as React from "react";
import { useContext } from "react";
import { List, ListItemButton, ListItemIcon, ListItemText, SwipeableDrawer } from "@mui/material";
import { drawerWidth, toolbarHeight } from "../../utils/commonValues";
import { styled, useMediaQuery, useTheme } from "@mui/system";
import { isEmpty } from "lodash-es";
import { LanguageContext } from "../../context/LanguageContext";
import { NavLink } from "react-router-dom";
import Divider from "@mui/material/Divider";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import PropTypes from "prop-types";
import NavigationToolbar from "./NavigationToolbar";
import Rendered from "../Rendered";
import { contactHasRight } from "../../utils/commonFunctions";
import { CustomerContext } from "../../context/CustomerContext";

const ListItemButtonStyled = styled(ListItemButton)(({ theme }) => ({
  "&:hover": {
    backgroundColor: theme.palette.secondary.contrastText,
    textDecoration: "underline"
  }
}));

function MobileMenuDrawer({ open, setDrawerOpen, menuItems, selectedMenuItem = {}, setSelectedMenuItem, parent }) {
  const customerContext = useContext(CustomerContext);
  const languageContext = useContext(LanguageContext);
  const theme = useTheme();
  const smallView = useMediaQuery(theme.breakpoints.down("sm"));

  const handleDrawerClose = () => {
    setDrawerOpen(false);
    setSelectedMenuItem({});
  };

  const handleParentClick = (event, menuItem) => {
    event.preventDefault();
    setSelectedMenuItem(menuItem);
  };

  return (
    <SwipeableDrawer
      disableSwipeToOpen
      open={open}
      onOpen={() => setDrawerOpen(true)}
      onClose={handleDrawerClose}
      anchor={"right"}
      PaperProps={{
        sx: {
          height: `calc(100% - ${toolbarHeight(true)}px)`,
          top: toolbarHeight(true),
          width: smallView ? "100%" : drawerWidth
        }
      }}
      slotProps={{
        backdrop: { invisible: true }
      }}
    >
      <List
        sx={{
          height: "100%",
          overflowY: "auto",
          msOverflowStyle: "none",
          scrollbarWidth: "none"
        }}
      >
        <Rendered rendered={!isEmpty(selectedMenuItem)}>
          <ListItemButton
            onClick={() => setSelectedMenuItem({})}
            sx={{ "&:hover": { backgroundColor: theme.palette.secondary.contrastText } }}
            disableRipple
          >
            <ListItemIcon sx={{ minWidth: 30 }}>
              <ArrowBackIcon />
            </ListItemIcon>
            <ListItemText
              slotProps={{ primary: { fontSize: "16px", fontWeight: "bold" } }}
              primary={languageContext.dictionary[selectedMenuItem.label] || selectedMenuItem.label}
            />
          </ListItemButton>
          <Divider />
        </Rendered>
        {menuItems?.map((menuItem, index) =>
          <Rendered rendered={!!contactHasRight(customerContext.selectedContact.roles, menuItem.access) && !menuItem.hidden} key={index}>
            <ListItemButtonStyled
              component={NavLink}
              to={{ pathname: menuItem.url, state: { from: window.location.pathname } }}
              onClick={event => menuItem.children ? handleParentClick(event, menuItem) : setDrawerOpen(false)}
              disableRipple
            >
              <ListItemText
                primaryTypographyProps={{
                  ...(menuItem.children || parent ? {
                    fontSize: "16px",
                    fontWeight: "bold"
                  } : {
                    fontSize: "14px"
                  })
                }}
                primary={languageContext.dictionary[menuItem.label] || menuItem.label}
                sx={{ marginRight: "8px", flex: "0 1 auto" }}
              />
              <Rendered rendered={!!menuItem.children}>
                <ListItemIcon>
                  <KeyboardArrowRightIcon />
                </ListItemIcon>
              </Rendered>
            </ListItemButtonStyled>
            <Rendered rendered={menuItem.children || parent}>
              <Divider />
            </Rendered>
          </Rendered>
        )}
      </List>
      <NavigationToolbar renderMiniMenu />
    </SwipeableDrawer>
  );
}

MobileMenuDrawer.propTypes = {
  open: PropTypes.bool,
  setDrawerOpen: PropTypes.func,
  menuItems: PropTypes.array,
  selectedMenuItem: PropTypes.object,
  setSelectedMenuItem: PropTypes.func,
  parent: PropTypes.bool
};

export default MobileMenuDrawer;
